
import {SocialMedia} from './socialMedia';
import {EmailImage} from '../email/emailImage';
import {BaseSocial} from './baseSocial';
import {AbstractDecorator} from './abstractDecorator';
import {JsonObject, JsonProperty} from 'json2typescript';
import {ExternalLinkConverter} from '../../customJsonConverters/ExternalLinkConverter';
import {ExternalLink} from './externalLink';
import {TSMap} from 'typescript-map';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';
import {EmailImageConverter} from '../../customJsonConverters/EmailImageConverter';
@JsonObject('Twitter')
export class Twitter extends SocialMedia {


     // TODO: Tobe removed once inheritance concept is cleared in json2Typescritp

     /*@JsonProperty('shareClass')
     public shareClass = '';

     @JsonProperty('clickArea')
     public clickArea = '';

     @JsonProperty('configFile')
     public configFile = '';

     @JsonProperty('link',ExternalLinkConverter)
     public link = new ExternalLink();

     @JsonProperty('image')
     public image = '';*/
     //


     @JsonProperty('use_media_as_url',Boolean)
     _use_media_as_url = false;

     @JsonProperty('shareImage')
     shareImage = '';

     @JsonProperty('socialQuestion',EmailImageConverter)
     socialQuestion = new EmailImage();


     @JsonProperty('upload_picture')
     upload_picture = false;

     @JsonProperty('upload_video')
     upload_video = false;

     @JsonProperty('micrositeUrl')
     micrositeUrl = false;

     @JsonProperty('set_subscription_conditions_verified')
     set_subscription_conditions_verified = false;

     @JsonProperty('custom_url')
     custom_url = '';

     @JsonProperty('video_height')
     video_height = '';

     @JsonProperty('hashMessage',TSStringToStringMapConverter)
     hashMessage:TSMap<string,string> = new TSMap(); // {[key:string]: string;} ={};



     constructor() {
       super();
       // this.socialQuestion = new EmailImage();

     }



}
